import React from 'react';
import logo from './logo.svg';
import './App.css';

import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { CacheProvider, EmotionCache } from "@emotion/react";
import { ThemeSettings } from "./theme/Theme";
import createEmotionCache from "./createEmotionCache";

import "./components/landingpage/testimonial/testimonial.css";
import "./components/landingpage/demo-slider/demo-slider.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./global/scrollbar.css";
import BlankLayout from './layouts/blank/BlankLayout';



import PageContainer from './components/container/PageContainer';
import Banner from './components/landingpage/banner/Banner';
import DemoSlider from './components/landingpage/demo-slider/DemoSlider';
import Frameworks from './components/landingpage/frameworks/Frameworks';
import Testimonial from './components/landingpage/testimonial/Testimonial';
import Features from './components/landingpage/features/Features';
import C2a from './components/landingpage/c2a/C2a';
import C2a2 from './components/landingpage/c2a/C2a2';
import Footer from './components/landingpage/footer/Footer';


// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache();

// interface MyAppProps extends AppProps {
//   emotionCache?: EmotionCache;
// }

function App() {

  const theme = ThemeSettings();


  return (
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.tsx</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>

    
    // <PageContainer>
    //   {/* <LpHeader /> */}
    //   <Banner />
    //   <DemoSlider />
    //   <Frameworks />
    //   <Testimonial />
    //   <Features />
    //   <C2a />
    //   <C2a2 />
    //   <Footer />
    // </PageContainer>


  // <SessionProvider session={session}>
      <CacheProvider value={clientSideEmotionCache}>
        {/* <Head>
          <meta name="viewport" content="initial-scale=1, width=device-width" />
          <title>Vulcano</title>
        </Head> */}
        <ThemeProvider theme={theme}>
              <CssBaseline />
              <BlankLayout>
                {/* <Component {...pageProps} /> */}

                <PageContainer>
                  {/* <LpHeader /> */}
                  <Banner />
                  {/* <DemoSlider /> */}
                  <Frameworks />
                  <Testimonial />
                  <Features />
                  <C2a />
                  <C2a2 />
                  <Footer />
                </PageContainer>

              </BlankLayout>
        </ThemeProvider>
      </CacheProvider>
    // </SessionProvider>
  );
}

export default App;
